import { createContext } from '@direct-frontend/modules-context';
import { $internals, FormInstance } from './types';

/**
 * Обьект formInitializationId - formInstance, хранит ссылку на обьект, на котором висят подписки
 */
export const frozenInstancesContext = createContext<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any --- универсальный тип инстанса для всех форм
    Record<string, FormInstance<any, any, any, any, any, any, any, any>>
>({
    name: `formsFrozenInstances`,
    getInitialValue() {
        return {};
    },
});

/**
 * Создает новый инстанс формы с замороженным ID и сохраняет его в frozenInstances
 */
export const getOrCreateFrozenInstance = (
    initializationId: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any --- универсальный тип инстанса для всех форм
    formInstance: FormInstance<any, any, any, any, any, any, any, any>
) => {
    const frozenInstances = frozenInstancesContext.getContext();

    const alreadySavedInstance = frozenInstances[initializationId];

    if (alreadySavedInstance) {
        return alreadySavedInstance;
    }

    const instance = formInstance;
    instance[$internals].freezeInitializationId(initializationId);
    frozenInstances[initializationId] = instance;
    return instance;
};
